import type { PayrollItem } from "../types/payroll.types";

function trimStr(s?: string | null): string {
  return s?.trim() ?? "";
}

/**
 * Display label for a payroll line item employee.
 * Prefers server aliases (`employeeName` / `employeeFirstName`+`employeeLastName`),
 * then `employee.user`, then legacy `employee` name fields.
 */
export function payrollItemEmployeeLabel(item: PayrollItem): string {
  const direct = trimStr(item.employeeName);
  if (direct) return direct;

  const fromAliases = [
    trimStr(item.employeeFirstName),
    trimStr(item.employeeLastName),
  ]
    .filter(Boolean)
    .join(" ");
  if (fromAliases) return fromAliases;

  const e = item.employee;
  if (e) {
    const fromName = trimStr(e.name);
    if (fromName) return fromName;
    const fromParts = [trimStr(e.firstName), trimStr(e.lastName)]
      .filter(Boolean)
      .join(" ");
    if (fromParts) return fromParts;
    if (e.id != null) return `Employee #${e.id}`;
  }

  return item.employeeId != null ? `Employee #${item.employeeId}` : "—";
}
